import {
    Avatar,
    Badge,
    Box,
    Button,
    Circle,
    Divider,
    Flex,
    Heading,
    HStack,
    Icon,
    IconButton,
    Input,
    SimpleGrid,
    Text,
    Tooltip,
    VStack
} from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { FaBox, FaClock, FaCloudUploadAlt, FaEnvelope, FaHistory, FaMapMarkerAlt, FaPaperclip, FaPhotoVideo, FaPrint, FaStackExchange, FaStickyNote, FaTasks, FaUserCheck } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { deletePickupAttachements, getPickupDetails, uploadPickupAttachements } from '../../api';
import ImageLightbox from '../../components/ImageLightBox';
import { hasPermission } from '../../Utils';
import PickupNotes from './PickupNotes';
const formatDate = (date) => dayjs(date).format('MMM D, YYYY h:mm A');

const noReturn = ['pickupLocation', 'dropOffLocation', 'courier', 'noteText', 'folder']


const humanReadableField = (field) => {
    console.log(field)

    const fieldMappings = {
        status: "Status",
        attachments: "Attachments",
        samplesReceived: "Samples Received",
        samplesCount: "Samples Count",
        "requirements.requestPhoto": "Request Photo",
        "requirements.hasSupplies": "Has Supplies",
        "requirements.hasDocs": "Has Documents",
        "priority": "Priority",
        "receivedBy": "Received By",
        timestamps: "Time Stamp",
        attachments: "Attachments"
    };

    return fieldMappings[field] || field.replace(/\./g, " "); // Default fallback: replace dots with spaces
};

const formatValue = (value, field) => {
    if (typeof value === "boolean") return value ? "Yes" : "No";
    if (value === null || value === undefined) return "N/A";
    if (typeof value === "string") return value; // Return the string as is, without JSON.stringify
    if (typeof value === "object" && field === "timestamps") {
        return (
            <>
                <Text mb={3}>Pickup Time: {new Date(value.pickupTime).toLocaleString()}</Text>
                <Divider />
                <Text mt={3}>Received Time: {new Date(value.receivedTime).toLocaleString()}</Text>
            </>
        )
    }

    if (typeof value === "object" && value !== null && (value.pickupTime || value.dropOffTime || value.receivedTime)) {
        return (
            <>
                {value.pickupTime && <Text>Pickup Time: {new Date(value.pickupTime).toLocaleString()}</Text>}
                {value.dropOffTime && <Text>Drop-off Time: {new Date(value.dropOffTime).toLocaleString()}</Text>}
                {value.receivedTime && <Text>Received Time: {new Date(value.receivedTime).toLocaleString()}</Text>}
            </>
        );
    }

    return JSON.stringify(value);



};

const ViewPickup = () => {
    const { id } = useParams()

    const [pickupDetail, setPickupDetail] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [selectedFiles, setSelectedFiles] = useState([]);



    useEffect(() => {
        getPickup();
    }, []);


    const getPickup = async (page = 1) => {
        setLoading(true);
        setError(null);
        try {
            const response = await getPickupDetails(id);
            if (response.success) {
                const pickupDetails = response.data;
                setPickupDetail(pickupDetails)
                console.log(pickupDetails)
            } else {
                setError(response.error);
            }
        } catch (error) {
            setError('Failed to load routes');
        }
        setLoading(false);
    };


    const status = (status) => {
        switch (status) {
            case 'PENDING':
                return "Pending";
            case 'PICKED_UP':
                return "Picked Up"
            case 'COMPLETED':
                return 'Received'
            case 'CANCELED':
                return "CANCELED"
            case 'RECEIVED':
                return "FINISHED"
            default:
                break;
        }
    }

    function getRequirementsIcons(requirements = {}) {
        const icons = [];


        if (requirements.hasDocs) {
            icons.push(
                <Tooltip label="This pickup has documents/envelopes" placement='top' key="docs">
                    <span><FaEnvelope size={15} /></span>
                </Tooltip>
            );
        }
        if (requirements.hasSupplies) {
            icons.push(
                <Tooltip label="This pickup has supplies" placement='top' key="supplies">
                    <span><FaBox size={15} /></span>
                </Tooltip>
            );
        }
        if (requirements.requestPhoto) {
            icons.push(
                <Tooltip label="This pickup requires a photo" placement='top' key="photo">
                    <span><FaPhotoVideo size={15} /></span>
                </Tooltip>
            );
        }


        return icons.length > 0 ? (
            <span style={{ display: 'flex', gap: '15px', alignItems: 'center', padding: 5 }}>
                {icons}
            </span>
        ) : "N/A";
    }


    const handleUpdatePickup = (updatedPickup) => {
        setPickupDetail(updatedPickup);
    };

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files); // Convert FileList to array
        const imageFiles = files.filter(file => file.type.startsWith('image/')); // Only keep image files
        setSelectedFiles(imageFiles);

        // Alert if some files are not images
        if (files.length !== imageFiles.length) {
            alert('Only image files are allowed.');
        }
    };

    // Handle file upload submission
    const handleFileUpload = async () => {
        if (selectedFiles.length === 0) {
            alert('No files selected');
            return;
        }

        console.log(pickupDetail)

        const formData = new FormData();
        selectedFiles.forEach((file) => {
            formData.append('documents', file);
        });
        formData.append('folder', 'couriers-attachements');

        try {

            const response = await uploadPickupAttachements(formData, pickupDetail._id)
            console.log(response)
            if (response.success) {
                // alert('Files uploaded successfully');
                getPickup()
                setSelectedFiles([]); // Clear selected files
                // onCloseViewModal(); // Optionally close the modal
            } else {
                alert(response.error);
            }
        } catch (error) {
            console.error('Error uploading files:', error);
            alert('Error uploading files');
        }
    };


    const handleDeleteAttachment = async (attachmentId) => {
        if (!window.confirm('Are you sure you want to delete this attachment?')) {
            return;
        }
        try {
            const response = await deletePickupAttachements(attachmentId, pickupDetail._id);
            if (response.success) {
                // Directly update pickupDetail's attachments
                pickupDetail.attachments = pickupDetail.attachments.filter(
                    (attachment) => attachment._id !== attachmentId
                );

                // Optionally, if pickupDetail is in state, trigger a re-render
                setPickupDetail({ ...pickupDetail });

                // alert("Attachment deleted successfully");
            } else {
                console.log(response.message || 'Failed to delete attachment');
            }
        } catch (error) {
            console.error('Error deleting attachment:', error);
            alert('Error deleting attachment');
        }
    };




    return (

        <Box>
            {/* Header */}
            <HStack spacing={6} mb={8} justifyContent="space-between">
                <HStack spacing={6}>
                    <Avatar size="xl" name={pickupDetail?.pickupLocation?.name || "PU"} />
                    <VStack align="start">
                        <Heading size="lg">
                            {pickupDetail?.pickupLocation?.name || pickupDetail?.dropOffLocation?.name || 'Pickup Details'}
                        </Heading>
                        <Text fontSize="sm" color="gray.600">
                            {pickupDetail?.pickupLocation?.address?.address1 || ''}
                            {pickupDetail?.pickupLocation?.address?.address2 ? `, ${pickupDetail?.pickupLocation?.address?.address2}` : ''}
                            {pickupDetail?.pickupLocation?.address?.city ? `, ${pickupDetail?.pickupLocation?.address?.city}` : ''}
                            {pickupDetail?.pickupLocation?.address?.state ? `, ${pickupDetail?.pickupLocation?.address?.state}` : ''}
                            {pickupDetail?.pickupLocation?.address?.zip ? `, ${pickupDetail?.pickupLocation?.address?.zip}` : ''}
                        </Text>
                        <Badge colorScheme="blue">{status(pickupDetail?.status)}</Badge>
                        <Text fontSize="sm" color="gray.500">Pickup ID: {pickupDetail?._id}</Text>
                    </VStack>
                </HStack>
                <Button colorScheme="gray" onClick={() => {
                    const newWindow = window.open('', '', 'width=800,height=1000');
                    newWindow.document.write(`
        <html>
          <head>
            <title>Pickup Summary</title>
            <style>
              body { font-family: Arial; padding: 40px; }
              h1 { text-align: center; }
              table { width: 100%; border-collapse: collapse; margin-top: 24px; }
              th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
              th { background: #f0f0f0; }
            </style>
          </head>
          <body>
            <h1>Pickup Summary – ${pickupDetail?.pickupLocation?.name || pickupDetail?.dropOffLocation?.name}</h1>
            <table>
              <tr><th>Pickup Address</th><td>
                ${pickupDetail?.pickupLocation?.address?.address1 || ''}
                ${pickupDetail?.pickupLocation?.address?.address2 ? `, ${pickupDetail?.pickupLocation?.address?.address2}` : ''}
                ${pickupDetail?.pickupLocation?.address?.city ? `, ${pickupDetail?.pickupLocation?.address?.city}` : ''}
                ${pickupDetail?.pickupLocation?.address?.state ? `, ${pickupDetail?.pickupLocation?.address?.state}` : ''}
                ${pickupDetail?.pickupLocation?.address?.zip ? `, ${pickupDetail?.pickupLocation?.address?.zip}` : ''}
              </td></tr>
              <tr><th>Pickup Date</th><td>${formatDate(pickupDetail?.timestamps?.pickupTime)}</td></tr>
              <tr><th>Courier</th><td>${pickupDetail?.courier?.name || 'N/A'}</td></tr>
              <tr><th>Type</th><td>${pickupDetail?.type || 'N/A'}</td></tr>
              <tr><th>Route</th><td>${pickupDetail?.routeId?.name || 'On Call'}</td></tr>
              <tr><th>Order #</th><td>${pickupDetail?.pickupOrder ?? 'N/A'}</td></tr>
              <tr><th>Request Photo</th><td>${pickupDetail?.requirements?.requestPhoto ? 'Yes' : 'No'}</td></tr>
              <tr><th>Has Supplies</th><td>${pickupDetail?.requirements?.hasSupplies ? 'Yes' : 'No'}</td></tr>
              <tr><th>Has Docs</th><td>${pickupDetail?.requirements?.hasDocs ? 'Yes' : 'No'}</td></tr>
              <tr><th>Received Time</th><td>${formatDate(pickupDetail?.timestamps?.receivedTime)}</td></tr>
              <tr><th>Created At</th><td>${formatDate(pickupDetail?.createdAt)}</td></tr>
              <tr><th>Route Pickup</th><td>${pickupDetail?.isRoutePickup ? 'Yes' : 'No'}</td></tr>
              <tr><th>Created By</th><td>${pickupDetail?.createdBy?.firstName || 'N/A'}</td></tr>
              <tr><th>Receiver</th><td>${pickupDetail?.receivedBy?.firstName || 'N/A'}</td></tr>
              <tr><th>Picked Samples</th><td>${pickupDetail?.samplesCount ?? 'N/A'}</td></tr>
              <tr><th>Received Samples</th><td>${pickupDetail?.samplesReceived ?? 'N/A'}</td></tr>
            </table>
          </body>
        </html>
      `);
                    newWindow.document.close();
                    newWindow.focus();
                    newWindow.print();
                    newWindow.close();
                }} leftIcon={<Icon as={FaPrint} />}>Print</Button>
            </HStack>

            {/* Main Grid */}
            <SimpleGrid templateColumns={{ base: '1fr', md: '3fr 1fr' }} spacing={8} p={8}>
                <Box>
                    {/* Pickup Overview */}
                    <Box mb={8} p={6} borderWidth="1px" borderRadius="lg">
                        <Heading size="md" mb={4}><Icon as={FaMapMarkerAlt} mr={2} />Pickup Overview</Heading>
                        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
                            <Text><b>Pickup Location:</b> {pickupDetail.pickupLocation?.name || 'N/A'}</Text>
                            <Text><b>Drop-off Location:</b> {pickupDetail.dropOffLocation?.name || 'N/A'}</Text>
                            <Text><b>Courier:</b> {pickupDetail.courier?.name || 'N/A'}</Text>
                            <Text><b>Type:</b> <Badge colorScheme="orange">{pickupDetail.type || 'N/A'}</Badge></Text>
                            <Text><b>Route:</b> <Badge colorScheme={pickupDetail.routeId?.name ? 'red' : 'green'}>{pickupDetail.routeId?.name || 'On Call'}</Badge></Text>
                            <Text><b>Order #:</b> <Badge colorScheme="purple">{pickupDetail.pickupOrder ?? 'N/A'}</Badge></Text>
                        </SimpleGrid>
                    </Box>


                    <Box mb={8} p={6} borderWidth="1px" borderRadius="lg">
                        <Heading size="md" mb={4}><Icon as={FaStackExchange} mr={2} />Pickup Status</Heading>
                        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>

                            <Text><b>Pickup Status:</b> <Badge colorScheme={pickupDetail.status === 'CANCELED' ? "red" : "green"}>{pickupDetail?.status}</Badge></Text>


                            {pickupDetail.status === 'CANCELED' &&
                                <>
                                    <Text><b>Pickup Status:</b> <Badge>{pickupDetail?.cancellation?.reason}</Badge></Text>
                                    <Text><b>Cancelation By:</b> <Badge>{pickupDetail?.cancellation?.by?.firstName + " " + pickupDetail?.cancellation?.by?.lastName}</Badge></Text>
                                    <Text><b>At:</b> <Badge>{new Date(pickupDetail?.cancellation?.date).toLocaleString()}</Badge></Text>
                                </>
                            }


                        </SimpleGrid>
                    </Box>



                    {/* Requirements */}
                    <Box mb={8} p={6} borderWidth="1px" borderRadius="lg">
                        <Heading size="md" mb={4}><Icon as={FaTasks} mr={2} />Pickup Requirements</Heading>
                        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
                            <Text><b>Request Photo:</b> <Badge colorScheme={pickupDetail?.requirements?.requestPhoto ? 'green' : 'gray'}>{pickupDetail?.requirements?.requestPhoto ? 'Yes' : 'No'}</Badge></Text>
                            <Text><b>Has Supplies:</b> <Badge colorScheme={pickupDetail?.requirements?.hasSupplies ? 'green' : 'gray'}>{pickupDetail?.requirements?.hasSupplies ? 'Yes' : 'No'}</Badge></Text>
                            <Text><b>Has Docs:</b> <Badge colorScheme={pickupDetail?.requirements?.hasDocs ? 'green' : 'gray'}>{pickupDetail?.requirements?.hasDocs ? 'Yes' : 'No'}</Badge></Text>
                        </SimpleGrid>
                    </Box>

                    {/* Metadata */}
                    <Box mb={8} p={6} borderWidth="1px" borderRadius="lg">
                        <Heading size="md" mb={4}><Icon as={FaClock} mr={2} />Pickup Metadata</Heading>
                        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
                            {pickupDetail.timestamps?.pickupTime &&
                                <Text><b>Pickup:</b> {formatDate(pickupDetail.timestamps?.pickupTime)}</Text>
                            }
                            {pickupDetail.timestamps?.receivedTime &&
                                <Text><b>Received:</b> {formatDate(pickupDetail.timestamps?.receivedTime)}</Text>
                            }
                            <Text><b>Created At:</b> {formatDate(pickupDetail.createdAt)}</Text>
                            <Text><b>Route Pickup:</b> <Badge colorScheme={pickupDetail.isRoutePickup ? 'green' : 'red'}>{pickupDetail.isRoutePickup ? 'Yes' : 'No'}</Badge></Text>
                            <Text><b>Created By:</b> {pickupDetail.createdBy?.firstName || 'N/A'}</Text>
                        </SimpleGrid>
                    </Box>

                    {/* Receiver Info */}
                    <Box mb={8} p={6} borderWidth="1px" borderRadius="lg">
                        <Heading size="md" mb={4}><Icon as={FaUserCheck} mr={2} />Receiver Info</Heading>
                        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
                            <Text><b>Name:</b> {pickupDetail?.receivedBy?.firstName || 'N/A'}</Text>
                            <Text><b>Picked:</b> {pickupDetail?.samplesCount ?? 'N/A'}</Text>
                            <Text><b>Received:</b> {pickupDetail?.samplesReceived ?? 'N/A'}</Text>
                        </SimpleGrid>
                    </Box>

                    {/* Notes */}
                    <Box mb={8} p={6} borderWidth="1px" borderRadius="lg">
                        <Heading size="md" mb={4}><Icon as={FaStickyNote} mr={2} />Pickup Notes</Heading>
                        {/* Notes */}
                        <PickupNotes
                            pickupId={pickupDetail?._id}
                            existingNotes={pickupDetail?.notes}
                            addNote={pickupDetail?.status === 'PENDING' || pickupDetail?.status === 'PICKED_UP'}
                        />
                    </Box>
                </Box>

                {/* Right Column: Attachments and Timeline */}
                <Box p={6} borderWidth="1px" borderRadius="lg">
                    <Heading size="md" mb={4}><Icon as={FaPaperclip} mr={2} />Attachments</Heading>
                    {hasPermission('uploadAttachments') && (
                        <HStack mb={3}>
                            <Input id="file-input" type="file" accept="image/*" multiple display="none" onChange={handleFileChange} />
                            <IconButton icon={<FaCloudUploadAlt />} aria-label="Upload Files" onClick={() => document.getElementById('file-input').click()} />
                            {selectedFiles.length > 0 && (
                                <Button size="sm" onClick={() => handleFileUpload(selectedFiles)}>
                                    Submit {selectedFiles.length} file(s)
                                </Button>
                            )}
                        </HStack>
                    )}
                    <SimpleGrid columns={[2, 3]} spacing={4} mt={4}>
                        {pickupDetail?.attachments?.filter(a => !a.deletedAt).map((attachment, index) => (
                            <Box key={index} position="relative">
                                <ImageLightbox
                                    imageUrl={
                                        attachment.fileUrl.startsWith('/uploads/couriers-attachments/')
                                            ? process.env.REACT_APP_IMAGES_LOCAL + attachment.fileUrl.replace('/uploads/couriers-attachments', '/ups/uploads/couriers-attachments')
                                            : process.env.REACT_APP_IMAGES + attachment.fileUrl.replace('/uploads', '/ups/uploads')
                                    }
                                    imageUploadedAt={attachment.uploadedAt}
                                    imageUploadedBy={attachment.uploadedBy}
                                    altText="Pickup Attachment"
                                    boxSize="64px"
                                    borderRadius="md"
                                    boxShadow="md"
                                />
                                {hasPermission('deleteAttachments') && (
                                    <Button
                                        size="xs"
                                        colorScheme="red"
                                        position="absolute"
                                        top="0"
                                        right="0"
                                        onClick={() => handleDeleteAttachment(attachment._id)}
                                    >X</Button>
                                )}
                            </Box>
                        ))}
                    </SimpleGrid>


                    <Divider h={3} mt={4} mb={4} />
                    {/* Timeline */}

                    <Box mt={4}>

                        <Heading size="md" mb={9}><Icon as={FaHistory} mr={2} />Pickup Logs</Heading>

                        {pickupDetail?.lastUpdated?.length > 0 &&
                            pickupDetail?.lastUpdated.map((log, index) => (
                                <>
                                    <HStack align="start" key={index}>
                                        {/* Timeline Marker */}
                                        <Flex direction="column" align="center">
                                            <Circle size="10px" bg="blue.500" />
                                            {index < pickupDetail?.lastUpdated.length - 1 && <Box h="90px" w="2px" bg="gray.300" />}
                                        </Flex>

                                        {/* Timeline Content */}
                                        <Box style={{ width: '100%' }}>
                                            <Text fontSize="sm" color="gray.500">
                                                {new Date(log?.timestamp).toLocaleString()}
                                            </Text>
                                            <Text fontSize="lg" fontWeight="bold">{log?.action}</Text>
                                            <Text fontSize="md" color="gray.600">
                                                {log?.action === 'Pickup Requested' ? `Requested By ${log?.updatedBy?.firstName || "Unknown User"}` : log?.action === 'Courier Update' ? "Courier Update" : " "}
                                            </Text>
                                            <Text fontSize={"sm"} color={"gray"}>by {log?.updatedBy?.firstName}</Text>
                                            <Box mt={2}>
                                                <SimpleGrid >
                                                    {log.fields.map((field, fieldIndex) => (
                                                        noReturn.includes(field.field) ? null :
                                                            <Box key={fieldIndex} mb={2}>
                                                                <Text fontSize="sm" color="gray.600">
                                                                    <strong>{humanReadableField(field.field)}</strong>:
                                                                </Text>
                                                                <Text fontSize="sm" color="gray.500">
                                                                    Previously : <strong>{formatValue(field.previousValue)}</strong>
                                                                </Text>
                                                                <Text fontSize="sm" color="gray.500">
                                                                    Changed To : <strong>{formatValue(field.newValue, field.field)}</strong>
                                                                </Text>
                                                            </Box>
                                                    ))}
                                                </SimpleGrid>
                                            </Box>
                                        </Box>
                                    </HStack>
                                    <Divider />
                                </>
                            ))}
                    </Box>
                </Box>
            </SimpleGrid>
        </Box>


        // <Box maxW="full" mx="auto" p="8" >
        //     <VStack spacing={6} align="stretch">
        //         {loading ?
        //             <Center mt={"20%"}>
        //                 <Loading />
        //             </Center>
        //             :
        //             <>
        //                 {error ? <AccessDenied msg={error} /> :


        //                     <Box>
        //                         <Heading>{pickupDetail?.pickupLocation?.name || pickupDetail?.dropOffLocation?.name}
        //                             <Badge ml={5} p={1} colorScheme={"blue"}>
        //                                 {status(pickupDetail?.status)}
        //                             </Badge>
        //                         </Heading>





        //                         <Flex p={6} gap={6} wrap="wrap" bg="gray.50" borderRadius="lg" boxShadow="md">
        //                             {/* LEFT COLUMN */}
        //                             <Box flex={1} minW="300px" bg="white" borderRadius="lg" p={6} boxShadow="sm">
        //                                 <Heading size="lg" mb={4}>Pickup Overview</Heading>

        //                                 <VStack align="start" spacing={5}>
        //                                     <Box>
        //                                         <Heading size="sm">Pickup Location</Heading>
        //                                         <Text fontWeight="semibold">{pickupDetail.pickupLocation?.name || "N/A"}</Text>
        //                                         <Text fontSize="sm" color="gray.600">
        //                                             ({pickupDetail.pickupLocation?.address?.city || "N/A"}) &bull;{' '}
        //                                             <Link href={getGoogleMapsLink(pickupDetail.pickupLocation?.address)} isExternal color="blue.500">
        //                                                 <FaMapMarkerAlt /> View Map
        //                                             </Link>
        //                                         </Text>
        //                                     </Box>

        //                                     <Box>
        //                                         <Heading size="sm">Drop-off Location</Heading>
        //                                         <Text fontWeight="semibold">{pickupDetail.dropOffLocation?.name || "N/A"}</Text>
        //                                         <Text fontSize="sm" color="gray.600">
        //                                             ({pickupDetail.dropOffLocation?.address?.city || "N/A"})
        //                                         </Text>
        //                                     </Box>

        //                                     <Box>
        //                                         <Heading size="sm">Courier</Heading>
        //                                         <Text fontWeight="semibold">{pickupDetail.courier?.name || "N/A"}</Text>
        //                                         <HStack mt={1} spacing={3}>
        //                                             <Badge colorScheme={pickupDetail.type === 'DropOffOnly' ? 'pink' : pickupDetail.type === 'Supplies' ? 'purple' : 'orange'}>{pickupDetail.type || "N/A"}</Badge>
        //                                             <Badge colorScheme={pickupDetail.routeId?.name ? 'red' : 'green'}>{pickupDetail.routeId?.name || "On Call"}</Badge>
        //                                             <Badge colorScheme="purple">Order #{pickupDetail.pickupOrder ?? "N/A"}</Badge>
        //                                         </HStack>
        //                                     </Box>

        //                                     <Box>
        //                                         <Heading size="sm">Requirements</Heading>
        //                                         {getRequirementsIcons(pickupDetail.requirements)}
        //                                     </Box>

        //                                     <Box>
        //                                         <Heading size="sm">Receiver</Heading>
        //                                         <VStack align="start" spacing={1} fontSize="sm">
        //                                             <Text><strong>Name:</strong> {pickupDetail?.receivedBy?.firstName || "N/A"}</Text>
        //                                             <Text><strong>Picked:</strong> {pickupDetail?.samplesCount ?? "N/A"}</Text>
        //                                             <Text><strong>Received:</strong> {pickupDetail?.samplesReceived ?? "N/A"}</Text>
        //                                         </VStack>
        //                                     </Box>
        //                                 </VStack>
        //                             </Box>

        //                             {/* MIDDLE COLUMN */}
        //                             <Box flex={1} minW="280px" bg="white" borderRadius="lg" p={6} boxShadow="sm">
        //                                 <Heading size="lg" mb={4}>Pickup Metadata</Heading>
        //                                 <VStack align="start" spacing={5}>
        //                                     <Box>
        //                                         <Heading size="sm">Timestamps</Heading>
        //                                         <VStack align="start" spacing={1} fontSize="sm">
        //                                             <Text><strong>Pickup:</strong> {pickupDetail.timestamps?.pickupTime ? formatDate(pickupDetail.timestamps.pickupTime) : "N/A"}</Text>
        //                                             <Text><strong>Drop Off:</strong> {pickupDetail.timestamps?.dropOffTime ? formatDate(pickupDetail.timestamps.dropOffTime) : "N/A"}</Text>
        //                                             <Text><strong>Received:</strong> {pickupDetail.timestamps?.receivedTime ? formatDate(pickupDetail.timestamps.receivedTime) : "N/A"}</Text>
        //                                         </VStack>
        //                                     </Box>

        //                                     <Box>
        //                                         <Heading size="sm">Additional Info</Heading>
        //                                         <Text fontSize="sm"><strong>Created At:</strong> {pickupDetail.createdAt ? formatDate(pickupDetail.createdAt) : "N/A"}</Text>
        //                                         <HStack fontSize="sm">
        //                                             <Text><strong>Route Pickup:</strong></Text>
        //                                             <Badge colorScheme={pickupDetail.isRoutePickup ? 'green' : 'red'}>{pickupDetail.isRoutePickup ? "Yes" : "No"}</Badge>
        //                                         </HStack>
        //                                         <Text fontSize="sm"><strong>Pickup Order:</strong> {pickupDetail.pickupOrder ?? "N/A"}</Text>
        //                                     </Box>

        //                                     <Box>
        //                                         <Heading size="sm">Created By</Heading>
        //                                         <HStack spacing={2} fontSize="sm">
        //                                             {pickupDetail.createdBy?.profilePicture && <Avatar size="sm" src={pickupDetail.createdBy.profilePicture} />}
        //                                             <Text>{pickupDetail.createdBy?.firstName || 'N/A'}</Text>
        //                                         </HStack>
        //                                     </Box>
        //                                 </VStack>
        //                             </Box>

        //                             {/* RIGHT COLUMN */}
        //                             <Box flex={1} minW="300px" bg="white" borderRadius="lg" p={6} boxShadow="sm">
        //                                 <Heading size="lg" mb={4}>Attachments</Heading>

        //                                 {hasPermission('uploadAttachments') && (
        //                                     <HStack mb={3}>
        //                                         <Input
        //                                             id="file-input"
        //                                             type="file"
        //                                             accept="image/*"
        //                                             multiple
        //                                             display="none"
        //                                             onChange={handleFileChange}
        //                                         />
        //                                         <IconButton
        //                                             icon={<FaCloudUploadAlt />}
        //                                             aria-label="Upload Files"
        //                                             onClick={() => document.getElementById('file-input').click()}
        //                                         />
        //                                         {selectedFiles.length > 0 && (
        //                                             <Button size="sm" onClick={() => handleFileUpload(selectedFiles)}>
        //                                                 Submit {selectedFiles.length} file(s)
        //                                             </Button>
        //                                         )}
        //                                     </HStack>
        //                                 )}

        //                                 <SimpleGrid columns={[2, 3]} spacing={4} mt={4}>
        //                                     {pickupDetail?.attachments?.filter(a => !a.deletedAt).map((attachment, index) => (
        //                                         <Box key={index} position="relative">
        //                                             <ImageLightbox
        //                                                 imageUrl={process.env.REACT_APP_IMAGES + attachment.fileUrl.replace('uploads/', '')}
        //                                                 imageUploadedAt={attachment.uploadedAt}
        //                                                 imageUploadedBy={attachment.uploadedBy}
        //                                                 altText="Pickup Attachment"
        //                                                 boxSize="64px"
        //                                                 borderRadius="md"
        //                                                 boxShadow="md"
        //                                             />
        //                                             {hasPermission('deleteAttachments') && (
        //                                                 <Button
        //                                                     size="xs"
        //                                                     colorScheme="red"
        //                                                     position="absolute"
        //                                                     top="0"
        //                                                     right="0"
        //                                                     onClick={() => handleDeleteAttachment(attachment._id)}
        //                                                 >X</Button>
        //                                             )}
        //                                         </Box>
        //                                     ))}
        //                                 </SimpleGrid>
        //                             </Box>
        //                         </Flex>



        //                         <Divider mb={8} mt={4} />



        //                         <Divider mb={8} mt={4} />
        //                         <PickupNotes pickupId={pickupDetail?._id} existingNotes={pickupDetail?.notes} addNote={pickupDetail?.status === 'PENDING' || pickupDetail?.status === 'PICKED_UP'} />


        //                         <Divider mb={8} mt={4} />

        //                         {/* Left Column (25% width) */}
        //                         <Box flex={["1 1 100%", "1 1 48%"]} maxHeight="550px" overflowY="auto" bg="gray.50" p={4} boxShadow="md">
        //                             {/* Content for the left column goes here */}
        //                             <VStack spacing={6} align="start" p={4}>
        //                                 {/* Timeline for pickup creation */}
        //                                 {pickupDetail?.lastUpdated[0]?.action === 'Pickup Requested' ? null :

        //                                     <HStack align="start" spacing={4}>
        //                                         {/* Timeline Marker */}
        //                                         <Flex direction="column" align="center">
        //                                             <Circle size="10px" bg="blue.500" />
        //                                             <Box h="100px" w="2px" bg="gray.300" />
        //                                         </Flex>
        //                                         {/* Timeline Content */}


        //                                         <Box>
        //                                             <Text fontSize="sm" color="gray.500">
        //                                                 {new Date(pickupDetail?.createdAt).toLocaleString()}
        //                                             </Text>
        //                                             <Text fontSize="lg" fontWeight="bold">
        //                                                 Pickup Created
        //                                             </Text>
        //                                             <Text fontSize="md" color="gray.600">
        //                                                 Pickup was{" "}
        //                                                 {pickupDetail?.routeId?.name ? (
        //                                                     <>
        //                                                         generated from route{" "}
        //                                                         <Popover>
        //                                                             <PopoverTrigger>
        //                                                                 <Text
        //                                                                     as="span"
        //                                                                     fontWeight="bold"
        //                                                                     color="blue.500"
        //                                                                     cursor="pointer"
        //                                                                 >
        //                                                                     {pickupDetail?.routeId?.name}
        //                                                                 </Text>
        //                                                             </PopoverTrigger>
        //                                                             <PopoverContent>
        //                                                                 <PopoverArrow />
        //                                                                 <PopoverCloseButton />
        //                                                                 <PopoverHeader fontWeight="bold" fontSize="lg">
        //                                                                     {pickupDetail?.routeId?.name}
        //                                                                 </PopoverHeader>
        //                                                                 <PopoverBody>
        //                                                                     <VStack align="start" spacing={2}>
        //                                                                         <Text fontSize="sm">
        //                                                                             {pickupDetail?.routeId?.cities}
        //                                                                         </Text>
        //                                                                     </VStack>
        //                                                                 </PopoverBody>
        //                                                             </PopoverContent>
        //                                                         </Popover>
        //                                                     </>
        //                                                 ) : (
        //                                                     "added"
        //                                                 )}{" "}
        //                                                 By {pickupDetail?.createdBy?.firstName}
        //                                             </Text>


        //                                         </Box>
        //                                     </HStack>
        //                                 }

        //                                 {/* Scrollable Timeline */}
        //                                 <Box w="100%" pt={2}>
        //                                     {pickupDetail?.lastUpdated?.length > 0 &&
        //                                         pickupDetail?.lastUpdated.map((log, index) => (
        //                                             <>
        //                                                 <HStack align="start" spacing={4} mt={4} pb={3} key={index}>
        //                                                     {/* Timeline Marker */}
        //                                                     <Flex direction="column" align="center">
        //                                                         <Circle size="10px" bg="blue.500" />
        //                                                         {index < pickupDetail?.lastUpdated.length - 1 && <Box h="90px" w="2px" bg="gray.300" />}
        //                                                     </Flex>

        //                                                     {/* Timeline Content */}
        //                                                     <Box style={{ width: '100%' }}>
        //                                                         <Text fontSize="sm" color="gray.500">
        //                                                             {new Date(log?.timestamp).toLocaleString()}
        //                                                         </Text>
        //                                                         <Text fontSize="lg" fontWeight="bold">{log?.action}</Text>
        //                                                         <Text fontSize="md" color="gray.600">
        //                                                             {log?.action === 'Pickup Requested' ? `Requested By ${log?.updatedBy?.firstName || "Unknown User"}` : log?.action === 'Courier Update' ? "Courier Update" : " "}
        //                                                         </Text>
        //                                                         <Text fontSize={"sm"} color={"gray"}>by {log?.updatedBy?.firstName}</Text>
        //                                                         <Box mt={2}>
        //                                                             <SimpleGrid columns={3} spacing={4}>
        //                                                                 {log.fields.map((field, fieldIndex) => (
        //                                                                     noReturn.includes(field.field) ? null :
        //                                                                         <Box key={fieldIndex} mb={2}>
        //                                                                             <Text fontSize="sm" color="gray.600">
        //                                                                                 <strong>{humanReadableField(field.field)}</strong>:
        //                                                                             </Text>
        //                                                                             <Text fontSize="sm" color="gray.500">
        //                                                                                 Previously : <strong>{formatValue(field.previousValue)}</strong>
        //                                                                             </Text>
        //                                                                             <Text fontSize="sm" color="gray.500">
        //                                                                                 Changed To : <strong>{formatValue(field.newValue, field.field)}</strong>
        //                                                                             </Text>
        //                                                                         </Box>
        //                                                                 ))}
        //                                                             </SimpleGrid>
        //                                                         </Box>
        //                                                     </Box>
        //                                                 </HStack>
        //                                                 <Divider />
        //                                             </>
        //                                         ))}
        //                                 </Box>
        //                             </VStack>
        //                         </Box>

        //                     </Box>
        //                 }

        //             </>
        //         }
        //     </VStack>
        // </Box>
    );
};

export default ViewPickup;
